import { useQuery } from '@tanstack/react-query';
import { API_TAGS } from '@/shared/api';
import { fetchKnowledgeSource } from './api';

/**
 * Query keys for knowledge sources
 */
export const knowledgeSourcesKeys = {
  all: [API_TAGS.KNOWLEDGE_SOURCES] as const,
  details: () => [...knowledgeSourcesKeys.all, 'detail'] as const,
  detail: (id: string | number) => [...knowledgeSourcesKeys.details(), Number(id)] as const,
};

/**
 * Хук получения источника знаний по идентификатору.
 * Без идентификатора запрос не уходит, а ключ остаётся на уровне `details()`: ключ детали строится
 * только по реальному идентификатору, иначе в него попал бы `Number(undefined)`
 */
export const useKnowledgeSource = (id?: number | string) => {
  return useQuery({
    queryKey: id ? knowledgeSourcesKeys.detail(id) : knowledgeSourcesKeys.details(),
    queryFn: () => fetchKnowledgeSource(id!),
    enabled: !!id,
    retry: false,
  });
};
